import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createDraft } from 'src/app/pages/homepage/shared/api';
import { createRecommendedPetitionAnglesJob } from 'src/app/shared/api/recommendedPetitionAngles';

export function useCreateRecommendations() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (issue: string) => {
			let recommendationsJobId: string | undefined;
			try {
				const { responseId } = await createRecommendedPetitionAnglesJob();
				recommendationsJobId = responseId;
			} catch {
				// If the job creation fails, we still want to proceed with creating a draft without the job ID.
			}

			const draft = {
				input: { issuePrompt: issue },
				type: 'recommendations_variant_b_draft' as const,
				metadata: { recommendationsJobId },
			};

			return createDraft(draft, { queryClient });
		},
	});
}
